export function isShipperHQActive(integrationsData) {
  if (!integrationsData?.agency_integrations) {
    return false
  }

  const shipperHQ = integrationsData.agency_integrations.find(
    integration => integration.system_name === 'shipper_hq'
  )

  return shipperHQ?.is_active === true
}
